(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TicketPaymentDialogController', TicketPaymentDialogController);

    TicketPaymentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TicketPayment', 'Passenger', 'Customer'];

    function TicketPaymentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TicketPayment, Passenger, Customer) {
        var vm = this;

        vm.ticketPayment = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.passengers = Passenger.query();
        vm.customers = Customer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ticketPayment.id !== null) {
                TicketPayment.update(vm.ticketPayment, onSaveSuccess, onSaveError);
            } else {
                TicketPayment.save(vm.ticketPayment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:ticketPaymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.departureDate = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
